import { MenuItem } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import {
  NavigationBar,
  NavigationItem,
  NavigationDropdownItem,
  locationShape,
  sessionShape,
  withSession,
  withBrowser,
  withFlipper,
  NavigationDemoDataBanner,
  NavigationPermissionRequestsBanner,
} from "lcm-iot-commons";
import isElementHiddenViaFlipper from "lcm-iot-commons/client/lib/utils/flipperUtils";

type OwnProps = {
  session?: sessionShape;
  location?: locationShape;
  showNavigationItems?: boolean;
  flipper: {
    demoDataActive?: boolean;
    hideNavigationAppSwitcher?: boolean;
  };
};

const defaultProps: Partial<OwnProps> = {
  session: undefined,
  location: undefined,
  showNavigationItems: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function Navigation({
  // @ts-expect-error TS(2339) FIXME: Property 'browser' does not exist on type 'Props'.
  browser,
  session,
  location,
  showNavigationItems,
  flipper,
}: Props) {
  const loggedIn = (session as $TSFixMe)?.authenticated;

  const applicationSpecifics = (session as $TSFixMe)?.applicationSpecifics;

  const menuDropdownSubscriptions = (
    <NavigationDropdownItem
      active={/^\/app\/id\/subscriptions*/}
      translationKey="navigation.subscriptions"
    >
      <MenuItem
        id="navigation.services"
        target="/subscriptions/services"
        active={
          location &&
          (location as $TSFixMe).pathname === "/app/id/subscriptions/services"
        }
      >
        <FormattedMessage id="navigation.subscriptions.netilion_services" />
      </MenuItem>
      <MenuItem
        id="navigation.connect"
        target="/subscriptions/connect"
        active={
          location &&
          (location as $TSFixMe).pathname === "/app/id/subscriptions/connect"
        }
      >
        <FormattedMessage id="navigation.subscriptions.netilion_connect" />
      </MenuItem>
    </NavigationDropdownItem>
  );

  const menuItemEdgeDevices = (
    <MenuItem
      active={
        location && (location as $TSFixMe).pathname === "/app/id/edge_devices"
      }
      onClick={
        /* istanbul ignore next */ () => browser.navigateTo("/edge_devices")
      }
      data-testid="edge-devices"
    >
      <FormattedMessage id="navigation.edge_devices" />
    </MenuItem>
  );
  const navItemEdgeDevice = (
    <NavigationItem
      active={/^\/app\/id\/edge_devices.*/}
      translationKey="navigation.edge_devices"
      target="/edge_devices"
    />
  );

  const showAllObjects = applicationSpecifics?.show_all_objects;

  const allObjects = showAllObjects ? (
    <NavigationItem
      active={/^\/app\/id\/(nodes).*/}
      translationKey="navigation.all_objects"
      target="/nodes"
    />
  ) : null;

  const showNavigationDemoData = flipper.demoDataActive;
  const showNavigationAppSwitcher = !isElementHiddenViaFlipper(
    flipper,
    "hideNavigationAppSwitcher",
  );

  const navBar = loggedIn ? (
    <>
      {/* @ts-expect-error TS(2322) FIXME: Type '{ children: (Element | null)[]; name: string... Remove this comment to see the full error message */}
      <NavigationBar
        name="ID"
        mobileName="ID"
        location={location}
        showNavigationItems={showNavigationItems}
        showSupportItem={(session as $TSFixMe).subscriptionType === "paid"}
        showDemoData={showNavigationDemoData}
        showAppSwitcher={showNavigationAppSwitcher}
      >
        <NavigationItem
          active={/^\/app\/id(\/?$|\/profile.*)/}
          translationKey="navigation.profile"
          target="/profile"
        />
        {allObjects}
        <NavigationItem
          active={/^\/app\/id\/(administration|tenants|usergroups).*/}
          translationKey="navigation.administration"
          target="/administration"
        />
        {menuDropdownSubscriptions}
        {navItemEdgeDevice}
        {menuItemEdgeDevices}
      </NavigationBar>
      <div className="navigation-banner-container">
        {/* @ts-expect-error TS(2322) FIXME: Type '{ id: string; }' is not assignable to type '... Remove this comment to see the full error message */}
        <NavigationPermissionRequestsBanner id="open-permission-banner" />
        {/* @ts-expect-error TS(2322) FIXME: Type '{ id: string; }' is not assignable to type '... Remove this comment to see the full error message */}
        <NavigationDemoDataBanner id="demo-data-banner" />
      </div>
    </>
  ) : (
    <NavigationBar
      // @ts-expect-error TS(2322) FIXME: Type '{ name: string; mobileName: string; location... Remove this comment to see the full error message
      name="Netilion"
      mobileName="Netilion"
      location={location}
      showNavigationItems={showNavigationItems}
    />
  );

  return navBar;
}

Navigation.defaultProps = defaultProps;
// @ts-expect-error TS(2345)
export default withFlipper(withBrowser(withSession(Navigation)));
